import { Box, Stack } from "@mui/material";
import { SLTypography } from "components/slTypography";
import {
  VideoCardHowItWorks,
  VideoCardHowItWorksStatic,
} from "helpers/enum/constants";
import { useSelector } from "react-redux";
import { reduceMotionState } from "store/reduceMotionSlice";

const CreationOfSoulLink = () => {
  const reduceMotion = useSelector(reduceMotionState);

  return (
    <>
      <Box>
        <Stack>
          <SLTypography
            tabIndex={0}
            role="heading"
            variant="headLine"
            sx={{ paddingBottom: "15px", fontSize: { xs: "19px", md: "27px" } }}
            title="Why Soul Link Was Created?"
          >
            Why was Soul Link created?
          </SLTypography>
          <SLTypography
            tabIndex={0}
            variant="smallBody"
            sx={{ fontSize: { xs: "14px", md: "17px" } }}
            title="Your body is like a musical instrument. Every bone, cell, and tissue
            in your body can be tuned to a specific frequency to function
            optimally. Toxins, stress, negative life experiences, and many other
            factors can pull your cells out of tune. When cells in the body
            resonate at their optimal vibrational frequency it creates harmony,
            promoting health, balance, and relaxation. If cells vibrate in
            disharmony, it creates imbalance leaving the body susceptible to
            disease. This is explained in mainstream physics which states that
            Resonance Shapes Reality, therefore Optimal Resonance = Perfect
            Harmonic Equilibrium."
          >
            Your body and brain are deeply responsive to external stimuli,
            including sound and visual input, which can directly influence your
            mental, emotional, and physical well-being.
            <br />
            <br /> Stress, environmental factors, and traumatic experiences may
            interfere with your body’s natural rhythms and neurological balance.
            <br />
            <br /> Soul Link was created to provide a science-driven,
            non-invasive approach that uses targeted audio-visual stimulation to
            encourage cognitive responsiveness, emotional regulation, and
            whole-body wellness.
          </SLTypography>
          <Box
            component="img"
            src={reduceMotion ? VideoCardHowItWorksStatic : VideoCardHowItWorks}
            sx={{
              borderRadius: "10px",
              marginTop: "40px",
              marginBottom: "7px",
            }}
            tabIndex={0}
            alt="Animation Video"
          />
          <SLTypography
            tabIndex={0}
            variant="smallBody"
            sx={{ fontSize: { xs: "14px", md: "17px" }, marginBottom: "40px" }}
            title="[Over rugged, dry mountains, white clouds drift, casting fleeting shadows on the sunlit peaks]"
          >
            [Over rugged, dry mountains, white clouds drift, casting fleeting
            shadows on the sunlit peaks]
          </SLTypography>
          <SLTypography
            role="heading"
            variant="headLine"
            tabIndex={0}
            sx={{ paddingBottom: "15px", fontSize: { xs: "19px", md: "27px" } }}
          >
            The Proven benefits of Soul Link.
          </SLTypography>
          <SLTypography
            variant="smallBody"
            tabIndex={0}
            sx={{ fontSize: { xs: "14px", md: "17px" } }}
          >
            Chronic stress, unresolved trauma, and difficult emotional
            experiences, especially those formed early in life, can influence
            long-term mental, emotional, and physical well being. These patterns
            often go unnoticed but play a role in how we think, feel, and
            experience life.
            <br />
            <br /> Soul Link combines Restorative Music and Immersive Earth
            Videos to deliver targeted sensory input that encourages positive
            cognitive and emotional experiences, naturally and effortlessly.
            <br />
            <br /> Soul Link’s science-driven formula is designed to promote a
            sense of mental clarity, emotional balance, and overall well-being
            through consistent use. It is the only wellness tool of its kind
            created to encourage positive perception shifts and support mental
            well-being through non-invasive audio-visual stimulation.
          </SLTypography>
          {/* <SLTypography
            variant="smallBody"
            sx={{
              paddingTop: "15px",
              paddingBottom: "12px",
              fontSize: { xs: "14px", md: "17px" },
            }}
            tabIndex={0}
          >
            The combination of the Musical Mantras and the Visual formula has
            transformational abilities. It positively reprograms the brain
            without requiring much effort from the user. The transformation
            happens for the user as it doesn’t need to “teach” the user how to
            meditate. Just by creating a habit of experiencing the sound and
            video formula the user will reap cognitive and physical benefits.
            Soul Link is the only meditation formula that will effectively and
            positively reprogram the perception of the user without the need for
            hypnosis or verbal repetition.
          </SLTypography> */}
        </Stack>
      </Box>
    </>
  );
};

export default CreationOfSoulLink;
